import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { ActionsCentersLoadable } from './internal/components/ActionsCenters/ActionsCentersLoadable';
import { SearchEngineResultsPageContainer } from '../../common/components/serp/container';
import { IAppStore } from '../../common/state';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { SaveSearchModalProvider } from '../SaveSearchModalProvider';
import { SubscriptionsContainer } from '../Subscriptions';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IAppStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const { logger, microfrontendsRegistry } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <Provider store={reduxStore}>
          <UiKitRoot deviceType="desktop" useStaticDeviceType>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <ActionsCentersLoadable />
              <SaveSearchModalProvider>
                <SearchEngineResultsPageContainer />
                <SubscriptionsContainer reduxStore={reduxStore} />
              </SaveSearchModalProvider>
            </MicrofrontendProvider>
          </UiKitRoot>
        </Provider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
